import React, { useState, useEffect } from 'react';
import {
  Download,
  FileText,
  Type,
  Calendar,
  Eye,
  Trash2,
  Plus,
  Save,
  X,
  Upload,
  File,
  FileArchive,
  Image,
  ZoomIn,
  ZoomOut,
  Edit,
  Download as DownloadIcon,
  Loader2,
  XCircle,
  Pencil
} from 'lucide-react';
import './Downloads.css';
import Swal from 'sweetalert2';
import { ApiUrl, BaseUrl } from '../API/ApiUrl';
import Toast from "../components/Toast/Toast";

const Downloads = () => {
  const [formData, setFormData] = useState({
    downloadType: '',
    fileName: '',
    file: null
  });
  const [toast, setToast] = useState({
    show: false,
    message: "",
    type: "success"
  });
  const [editingId, setEditingId] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [showPdfModal, setShowPdfModal] = useState(false);
  const [currentPdf, setCurrentPdf] = useState(null);
  const [zoomLevel, setZoomLevel] = useState(100);
  // State for download types
  const [showTypeForm, setShowTypeForm] = useState(false);
  const [editingTypeId, setEditingTypeId] = useState(null);
  const [typeFormData, setTypeFormData] = useState({
    typeName: '',
  });


  const [downloadTypes, setDownloadTypes] = useState([]);

  const [downloadList, setDownloadList] = useState([]);
  const [saving, setSaving] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);

  const handleTypeInputChange = (e) => {
    const { name, value } = e.target;

    // Allow only letters + spaces
    const cleanedValue = value.replace(/[^A-Za-z\s]/g, "");

    setTypeFormData({
      ...typeFormData,
      [name]: cleanedValue
    });
  };

  const fetchDownloadTypes = async () => {
    try {
      const token = localStorage.getItem("adminToken");

      const response = await fetch(`${ApiUrl}/download-types`, {
        headers: {
          "Authorization": `Bearer ${token}`
        }
      });

      const data = await response.json();

      if (!response.ok) {
        setToast({ show: true, message: data.message, type: "error" });
        return;
      }

      setDownloadTypes(data);

    } catch (error) {
      setToast({ show: true, message: "Server error", type: "error" });
    }
  };

  useEffect(() => {
    fetchDownloadTypes();
  }, []);



  const handleTypeSubmit = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem("adminToken");
    setSaving(true);

    try {
      let response;

      if (editingTypeId) {
        response = await fetch(`${ApiUrl}/download-types/${editingTypeId}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify(typeFormData)
        });
      } else {
        response = await fetch(`${ApiUrl}/download-types`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify(typeFormData)
        });
      }

      const data = await response.json();

      if (!response.ok) {
        setToast({ show: true, message: data.message, type: "error" });
        return;
      }

      setToast({
        show: true,
        message: editingTypeId ? "Type updated successfully" : "Type added successfully",
        type: "success"
      });

      fetchDownloadTypes();
      setTypeFormData({ typeName: "" });
      setEditingTypeId(null);
      setShowTypeForm(false);

    } catch (error) {
      setToast({ show: true, message: "Server error", type: "error" });
    } finally {
      setSaving(false); // ✅ always executes
    }
  };

  const handleEditType = (type) => {
    setTypeFormData({
      typeName: type.type_name,
    });
    setEditingTypeId(type.id);
    setShowTypeForm(true);
  };

  const handleDeleteType = async (id) => {
    const token = localStorage.getItem("adminToken");

    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This type will be deleted permanently!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!"
    });

    if (!result.isConfirmed) return;

    try {
      const response = await fetch(`${ApiUrl}/download-types/${id}`, {
        method: "DELETE",
        headers: {
          "Authorization": `Bearer ${token}`
        }
      });

      const data = await response.json();

      if (!response.ok) {
        setToast({ show: true, message: data.message, type: "error" });
        return;
      }

      setToast({ show: true, message: "Type deleted successfully ", type: "success" });

      fetchDownloadTypes();

    } catch (error) {
      setToast({ show: true, message: "Server error", type: "error" });
    }
  };

  const handleCancelType = () => {
    setTypeFormData({ typeName: '' });
    setEditingTypeId(null);
    setShowTypeForm(false);
  };




  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };
  const handleCancel = () => {
    setFormData({ downloadType: '', fileName: '', file: null });
    setSelectedFile(null);
    setEditingId(null);
    setShowForm(false);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      setFormData({
        ...formData,
        fileName: file.name,
        file: file
      });
    }
  };


  const fetchDownloads = async () => {
    try {
      // const token = localStorage.getItem("adminToken");

      const response = await fetch(`${ApiUrl}/downloads`);

      const data = await response.json();

      if (!response.ok) {
        setToast({ show: true, message: data.message, type: "error" });
        return;
      }

      setDownloadList(data);

    } catch (error) {
      setToast({ show: true, message: "Server error", type: "error" });
    }
  };


  useEffect(() => {
    fetchDownloads();
  }, []);



  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem("adminToken");

    const existingItem = downloadList.find(
      (item) => item.download_type_id == formData.downloadType
    );
    let url = `${ApiUrl}/downloads`;
    let method = "POST";

    //  1. EDIT MODE (TOP PRIORITY)
    if (editingId) {
      url = `${ApiUrl}/downloads/${editingId}`;
      method = "PUT";
    }

    //  2. ADD MODE → CHECK DUPLICATE
    else if (existingItem) {
      const result = await Swal.fire({
        title: "Type already exists",
        text: "Do you want to update the existing file?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, update",
        cancelButtonText: "No"
      });

      if (!result.isConfirmed) return;

      url = `${ApiUrl}/downloads/${existingItem.id}`;
      method = "PUT";
    }

    setSaving(true);

    try {
      const formDataToSend = new FormData();
      formDataToSend.append("downloadType", formData.downloadType);

      if (selectedFile) {
        formDataToSend.append("file", selectedFile);
      }

      // console.log("========== DOWNLOAD SUBMIT ==========");
      // console.log("Editing ID:", editingId);
      // console.log("Existing Item:", existingItem);
      // console.log("Selected File:", selectedFile);
      // console.log("Final API URL:", url);
      // console.log("Final Method:", method);
      // console.log("====================================");

      const response = await fetch(url, {
        method,
        headers: {
          Authorization: `Bearer ${token}`
        },
        body: formDataToSend
      });

      const data = await response.json();

      // console.log("Response Status:", response.status);
      // console.log("Response OK:", response.ok);
      // console.log("Response Data:", data);
      if (!response.ok) {
        setToast({ show: true, message: data.message, type: "error" });
        return;
      }

      setToast({
        show: true,
        message:
          method === "PUT"
            ? "File updated successfully"
            : "File uploaded successfully",
        type: "success"
      });

      fetchDownloads();
      setFormData({ downloadType: "", fileName: "", file: null });
      setSelectedFile(null);
      setShowForm(false);
      setIsUpdating(false);
    } catch (error) {
      setToast({ show: true, message: "Server error", type: "error" });
    } finally {
      setSaving(false);
      setIsUpdating(false);
    }
  };


  const handleEdit = (item) => {
    // console.log("EDIT ITEM:", item);

    setFormData({
      downloadType: Number(item.download_type_id),
      fileName: item.file_name
    });

    setSelectedFile(null);
    setEditingId(item.id);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    const token = localStorage.getItem("adminToken");

    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This file will be permanently deleted!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!"
    });

    if (!result.isConfirmed) return;

    try {
      const response = await fetch(`${ApiUrl}/downloads/${id}`, {
        method: "DELETE",
        headers: {
          "Authorization": `Bearer ${token}`
        }
      });

      const data = await response.json();

      if (!response.ok) {
        setToast({ show: true, message: data.message, type: "error" });
        return;
      }

      setToast({ show: true, message: "File deleted successfully ", type: "success" });

      fetchDownloads();

    } catch (error) {
      setToast({ show: true, message: "Server error", type: "error" });
    }
  };

  // const handleViewPdf = (item) => {
  //   setCurrentPdf({
  //     ...item,
  //     fileUrl: `${BaseUrl}/${item.file_path}`

  //   });
  //   console.log("PDF URL:", `${BaseUrl}/${item.file_path}`);

  //   setZoomLevel(100);
  //   setShowPdfModal(true);
  // };

  const handleViewPdf = (item) => {
    const fileUrl = `${BaseUrl}/${item.file_path}`;
    const fileExtension = item.file_name.split('.').pop().toLowerCase();

    let viewUrl = fileUrl;

    // // 👇 If DOC/DOCX → use Google Docs Viewer
    // if (fileExtension === "doc" || fileExtension === "docx") {
    //   viewUrl = `https://docs.google.com/gview?url=${fileUrl}&embedded=true`;
    // }
    if (fileExtension === "doc" || fileExtension === "docx") {
      viewUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${fileUrl}`;
    }

    setCurrentPdf({
      ...item,
      fileUrl: viewUrl
    });

    setZoomLevel(100);
    setShowPdfModal(true);
  };

  const handleCloseModal = () => {
    setShowPdfModal(false);
    setCurrentPdf(null);
    setZoomLevel(100);
  };

  const handleZoomIn = () => {
    setZoomLevel(prev => Math.min(prev + 25, 200));
  };

  const handleZoomOut = () => {
    setZoomLevel(prev => Math.max(prev - 25, 50));
  };

  const handleDownload = (currentPdf) => {
    if (currentPdf) {
      // In real app, this would trigger file download
      // window.alert(`Downloading: ${currentPdf.fileName}`);
      window.open(`${BaseUrl}/${currentPdf}`, '_blank');

      // window.open(currentPdf.fileUrl, '_blank');
    }
  };

  const handlePrint = () => {
    if (currentPdf) {
      // In real app, this would print the PDF
      window.alert(`Printing: ${currentPdf.fileName}`);
    }
  };

  const getFileIcon = (fileType) => {
    switch (fileType) {
      case 'pdf':
        return <FileText size={14} className="file-icon pdf" />;
      case 'docx':
      case 'doc':
        return <FileText size={14} className="file-icon word" />;
      case 'zip':
      case 'rar':
        return <FileArchive size={14} className="file-icon archive" />;
      case 'jpg':
      case 'png':
      case 'gif':
        return <Image size={14} className="file-icon image" />;
      default:
        return <File size={14} className="name-icon" />;
    }
  };

  return (
    <div className="downloads-page">
      {/* Header */}
      <div className="page-header">
        <div className="title-section">
          <Download size={40} className="title-icon" />
          <div>
            <h1 className="page-title">Downloads</h1>
            <p className="page-subtitle">Manage downloadable files and resources</p>
          </div>
        </div>

        {!showForm && (
          <button className="btn-primary" onClick={() => setShowForm(true)}>
            <Plus size={16} />
            <span>Add New</span>
          </button>
        )}
      </div>

      {showTypeForm && (
        <div className="modal-overlay">
          <div className="modal-content large">
            <div className="modal-header">
              <h3>Manage Download Types</h3>
              <button className="btn-icon" onClick={() => setShowTypeForm(false)}>
                <X size={16} />
              </button>
            </div>

            {/* Add/Edit Form */}
            <div className="type-form-section">
              <h4>{editingTypeId ? 'Edit Download Type' : 'Add New Download Type'}</h4>
              <form onSubmit={handleTypeSubmit} className="type-form">
                <div className="form-group">
                  <input
                    type="text"
                    id="typeName"
                    name="typeName"
                    value={typeFormData.typeName}
                    onChange={handleTypeInputChange}
                    placeholder="Enter download type name"
                    required
                  />
                </div>

                <div className="download-type-actions">
                  {editingTypeId && (
                    <button type="button" disabled={saving} className="btn-secondary" onClick={handleCancelType}>
                      Cancel Edit
                    </button>
                  )}
                  <button type="submit" className="btn-primary" disabled={saving}>
                    {saving ? (
                      <>
                        <Loader2 size={16} className="spin-icon" />
                        <span>{editingTypeId ? 'Updating...' : 'Saving...'}</span>
                      </>
                    ) : (
                      <>
                        <Save size={14} />
                        <span>{editingTypeId ? 'Update' : 'Save'}</span>
                      </>
                    )}
                  </button>
                </div>
              </form>
            </div>

            {/* Types List Table */}
            <div className="types-list-section">
              <h4>Download Types List</h4>
              <div className="table-responsive">
                <table className="types-table">
                  <thead>
                    <tr>
                      <th>Sl. No</th>
                      <th>Type Name</th>
                      <th>Created Date</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {downloadTypes.map((type, index) => (
                      <tr key={type.id}>
                        <td>
                          <span className="sl-no">{index + 1}</span>
                        </td>
                        <td>
                          <div className="cell-content">
                            <Type size={14} className="cell-icon" />
                            {type.type_name}
                          </div>
                        </td>
                        <td>
                          <div className="cell-content">
                            <Calendar size={12} className="cell-icon" />
                            {type.created_at
                              ? new Date(type.created_at)
                                .toLocaleDateString("en-GB", {
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric"
                                })
                              : "-"}
                          </div>
                        </td>
                        <td>
                          <div className="action-buttons">

                            <button
                              className="action-btn edit"
                              onClick={() => handleEditType(type)}
                              title="Edit Type"
                            >
                              <Edit size={14} />
                            </button>
                            <button
                              className="action-btn delete"
                              onClick={() => handleDeleteType(type.id)}
                              title="Delete Type"
                            >
                              <Trash2 size={14} />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}


      {showForm && (
        <div className="form-card">
          <div className="form-header">
            <h3>{editingId ? 'Edit Download' : 'Add New Download'}</h3>
            <div className="form-download-btn">
              <button
                className="btn-primary"
                onClick={() => setShowTypeForm(true)}
              >
                <Plus size={16} />
                <span>Add Download Type</span>
              </button>
              <button className="btn-icon" onClick={handleCancel}>
                <X size={16} />
              </button>

            </div>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="downloadType">
                  <Type size={14} />
                  <span>Download Type <span className="required">*</span> </span>
                </label>
                <select
                  id="downloadType"
                  name="downloadType"
                  value={formData.downloadType}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">Select type</option>

                  {downloadTypes.map((type) => (
                    <option key={type.id} value={type.id}>
                      {type.type_name}
                    </option>
                  ))}

                </select>
              </div>

              <div className="form-group">
                <label htmlFor="file">
                  <Upload size={14} />
                  <span>Choose File(.doc, .docx, pdf)  <span className="required">*</span> </span>
                </label>
                <input
                  type="file"
                  id="file"
                  name="file"
                  accept=".pdf,.doc,.docx"
                  onChange={handleFileChange}
                  className="file-input"
                  required={!editingId && !isUpdating}
                />
                {editingId && (
                  <span className="file-name">
                    Existing: {formData.fileName}
                  </span>
                )}

                {selectedFile && (
                  <span className="file-name">
                    Selected: {selectedFile.name}
                  </span>
                )}
              </div>
            </div>

            <div className="form-actions">
              <button type="button" className="btn-secondary" onClick={handleCancel} disabled={saving}>
                Cancel
              </button>
              <button type="submit" className="btn-primary" disabled={saving}>
                {saving ? (
                  <>
                    <Loader2 size={16} className="spin-icon" />
                    <span>{editingId ? 'Updating...' : 'Saving...'}</span>
                  </>
                ) : (
                  <>
                    <Save size={14} />
                    <span>{editingId ? 'Update' : 'Save'}</span>
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      )}

      {/* Table */}
      <div className="table-card">
        <div className="table-header">
          <h3>Downloads List</h3>
          <span className="record-count">{downloadList.length} files</span>
        </div>

        <div className="table-responsive">
          <table className="downloads-table">
            <thead>
              <tr>
                <th>Sl. No</th>
                <th>Download Type</th>
                <th>File Name</th>
                <th>Size</th>
                <th>Upload Date</th>
                <th>Downloads</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {downloadList.map((item, index) => (
                <tr key={item.id}>
                  <td>
                    <span className="sl-no">{index + 1}</span>
                  </td>
                  <td>
                    <div className="cell-content">
                      {getFileIcon(item.fileType)}
                      {item.type_name}
                    </div>
                  </td>
                  <td>
                    <div className="cell-content">
                      <File size={12} className="cell-icon" />
                      {item.file_name}
                    </div>
                  </td>
                  <td>{item.file_size}</td>
                  <td>
                    <div className="cell-content">
                      <Calendar size={12} className="cell-icon" />
                      {item.upload_date
                        ? new Date(item.upload_date)
                          .toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric"
                          })
                        : "-"}
                    </div>
                  </td>
                  <td>
                    <div className="cell-content">
                      <DownloadIcon size={12} className="cell-icon" />
                      {item.download_count}
                    </div>
                  </td>
                  <td>
                    <div className="action-buttons">
                      <button
                        className="action-btn view"
                        onClick={() => handleViewPdf(item)}
                        title="View PDF"
                      >
                        <Eye size={14} />
                      </button>
                      <button
                        className="action-btn edit"
                        onClick={() => handleEdit(item)}
                        title="Edit"
                      >
                        <Edit size={14} />
                      </button>
                      <button
                        className="action-btn delete"
                        onClick={() => handleDelete(item.id)}
                        title="Delete"
                      >
                        <Trash2 size={14} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {showPdfModal && currentPdf && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="pdf-modal" onClick={e => e.stopPropagation()}>
            <div className="pdf-modal-header">
              <div className="pdf-title">
                <FileText size={18} className="pdf-icon" />
                <div>
                  <h3>{currentPdf.type_name}</h3>
                  <span className="pdf-filename">{currentPdf.file_name}</span>
                </div>
              </div>
              <div className="pdf-controls">
                <button
                  className="control-btn"
                  onClick={handleZoomOut}
                  title="Zoom Out"
                  disabled={zoomLevel <= 50}
                >
                  <ZoomOut size={16} />
                </button>
                <span className="zoom-level">{zoomLevel}%</span>
                <button
                  className="control-btn"
                  onClick={handleZoomIn}
                  title="Zoom In"
                  disabled={zoomLevel >= 200}
                >
                  <ZoomIn size={16} />
                </button>
                {/* <button 
                  className="control-btn" 
                  onClick={() => setZoomLevel(100)}
                  title="Reset Zoom"
                >
                  <RotateCw size={16} />
                </button> */}
                <button
                  className="control-btn"
                  onClick={() => handleDownload(currentPdf.file_path)}
                  title="Download"
                >
                  <DownloadIcon size={16} />
                </button>
                {/* <button
                  className="control-btn"
                  onClick={handlePrint}
                  title="Print"
                >
                  <Printer size={16} />
                </button> */}
                <button
                  className="control-btn close"
                  onClick={handleCloseModal}
                  title="Close"
                >
                  <XCircle size={16} />
                </button>
              </div>
            </div>

            <div className="pdf-viewer-container">
              <div
                className="pdf-viewer"
                style={{
                  transform: `scale(${zoomLevel / 100})`,
                  transformOrigin: 'center center'
                }}
              >
                <div className="pdf-page">
                  {/* This is a mock PDF viewer */}
                  <iframe
                    src={currentPdf.fileUrl}
                    title="PDF Viewer"
                    width="100%"
                    height="600px"
                    style={{
                      border: "none",
                      transform: `scale(${zoomLevel / 100})`,
                      transformOrigin: "top center"
                    }}
                  ></iframe>
                </div>
              </div>
            </div>

            <div className="pdf-modal-footer">
              <span>Page 1 of 1</span>
              <span className="file-info">
                {currentPdf.file_size} •
                {new Date(currentPdf.upload_date).toLocaleDateString("en-GB")}
              </span>            </div>
          </div>

        </div>
      )}

      {toast.show && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={() =>
            setToast(prev => ({ ...prev, show: false }))
          } />
      )}
    </div>
  );
};

export default Downloads;